import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import PrimeUserTracking from "~/components/tracking/PrimeUserTracking";
import withPrimeContext from "~/withPrimeContext";

export default withPrimeContext(
  withErrorBoundary(PrimeUserTracking, {
    name: "PrimeUserTracking",
  }),
);
